<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M19.5 15.5L12 8l-7.5 7.5"/>
</svg>
